import React, { useState } from 'react'

import { normalize, usePet } from '../../modules'

import Modal from "../resusable/modal"

const Complementary = ({ toggle, visible, order, onPerform, token }) => {
    const [amount, setComlementary] = useState(normalize(order.items.reduce((total, item) => total + (item.quantity * item.unitPrice), 0) - (order.discount ?? 0)))
    const [owner, setOwner] = useState()
    const [notes, setNotes] = useState()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Complementary has been given', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('giveComplementary', {
        bill: order?._id,
        amount,
        owner,
        notes,
        token
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Giving complementary...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Give Complementary"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How much of the bill are we taking care of?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        value={ amount }
                        onChange={ e => setComlementary(e.target.value)}
                        placeholder="Amount in Ksh" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Owner of Bill
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-owner"
                        type="text"
                        value={ owner }
                        onChange={ e => setOwner(e.target.value)}
                        placeholder="Simon Kamau" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Notes
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        value={ notes }
                        onChange={ e => setNotes(e.target.value)}
                        placeholder="Any reminders" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Give Complementary</button>
            </div>
        </Modal>
    )
}

export default Complementary